
import { Button } from '@/components/ui/button';
import MobileAnimatedBackground from './MobileAnimatedBackground';
import MobileWhySection from './MobileWhySection';

const MobileHeroSection = () => {
  return (
    <section className="pt-24 pb-8 bg-gradient-to-br from-gray-50 via-pink-50 to-white relative overflow-hidden">
      <MobileAnimatedBackground />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center max-w-4xl mx-auto mb-16">
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6 animate-fade-in">
            Business-Grade Mobile Plans,{' '}
            <span className="text-pink-600 relative">
              Powered by T-Mobile
              <div className="absolute -inset-1 bg-pink-100 rounded-lg opacity-50 animate-pulse -z-10"></div>
            </span>.
          </h1>
          
          <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto animate-fade-in" style={{animationDelay: '0.2s'}}>
            Tailored wireless solutions with business support you won't get at the store.
          </p>
          
          <div className="flex justify-center mb-8">
            <img 
              src="/lovable-uploads/a2e74efb-9ec6-4271-9a91-1b76d7f27a25.png" 
              alt="T-Mobile for Business Partner Program" 
              className="h-20 md:h-24 w-auto"
            />
          </div>
          
          <p className="text-lg text-gray-700 mb-8 max-w-3xl mx-auto animate-fade-in" style={{animationDelay: '0.4s'}}>
            As a T-Mobile Authorized Partner, we help registered businesses access powerful wireless plans, 
            simplified onboarding, and tailored customer care that meets your organization's needs.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in" style={{animationDelay: '0.6s'}}>
            <Button 
              size="lg" 
              className="bg-pink-600 hover:bg-pink-700 text-white transform hover:scale-105 transition-all duration-200 shadow-lg ring-vibrate"
              data-tally-open="mejLOk" 
              data-tally-emoji-text="👋" 
              data-tally-emoji-animation="wave"
            >
              Book a Business Consultation
            </Button>
          </div>
        </div>

        {/* Include Why Work With Us section here without header */}
        <div className="relative z-10">
          <MobileWhySection compact={true} />
        </div>
      </div>
    </section>
  );
};

export default MobileHeroSection;
